import * as React from 'react';
import 'perfect-scrollbar-react/dist/style.min.css';
import 'react-table/react-table.css';
import { Scrollbars } from 'react-custom-scrollbars';


export const CustomTbodyComponent = props => (
  <div {...props} className="rt-tbody">
    <Scrollbars>{props.children}</Scrollbars>
  </div>
);



// WEBPACK FOOTER //
// ./src/share/components/BodyTable/BodyTable.tsx